import { render } from "./RHModule.vue?vue&type=template&id=5a6c7888&scoped=true"
import script from "./RHModule.vue?vue&type=script&lang=js"
export * from "./RHModule.vue?vue&type=script&lang=js"

import "./RHModule.vue?vue&type=style&index=0&id=5a6c7888&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6c7888"]])

export default __exports__